import { Star } from 'lucide-react';

export const Stars = ({ value = 0, size = 14, className = '' }) => (
  <span className={`inline-flex items-center gap-0.5 ${className}`} role="img" aria-label={`Rated ${value} out of 5 stars`}>
    {[1, 2, 3, 4, 5].map((n) => (
      <Star key={n} style={{ width: size, height: size }} className={n <= value ? 'text-[#F59E0B] fill-[#F59E0B]' : 'text-[#D4D4D8]'} aria-hidden="true" />
    ))}
  </span>
);

export const RatingSummary = ({ aggregate, dark = false }) => {
  const { avg = 0, count = 0, verified = 0, distribution = {} } = aggregate || {};
  const ink = dark ? 'text-white' : 'text-[#111214]';
  const muted = dark ? 'text-zinc-400' : 'text-[#71717A]';
  const track = dark ? 'bg-white/10' : 'bg-[#E4E4E7]';
  const pct = count ? Math.round((verified / count) * 100) : 0;
  return (
    <div className="flex flex-col sm:flex-row gap-6 sm:gap-10" data-testid="reviews-aggregate-rating">
      <div>
        <div className="flex items-end gap-2">
          <span className={`font-display text-7xl leading-[0.85] ${ink}`} data-testid="reviews-avg">{count ? avg.toFixed(1) : '—'}</span>
          <span className={`font-mono text-sm pb-1 ${muted}`}>/ 5</span>
        </div>
        <Stars value={Math.round(avg)} size={18} className="mt-3" />
        <p className={`mt-2 text-sm ${muted}`} data-testid="reviews-count">
          {count} player review{count === 1 ? '' : 's'}{verified ? ` · ${pct}% order-verified` : ''}
        </p>
      </div>
      <ul className="flex-1 w-full sm:w-auto sm:min-w-[200px] space-y-1.5 self-stretch sm:self-center" aria-label="Rating distribution">
        {[5, 4, 3, 2, 1].map((n) => {
          const c = distribution[String(n)] || 0;
          const w = count ? Math.max(c ? 4 : 0, Math.round((c / count) * 100)) : 0;
          return (
            <li key={n} className="flex items-center gap-3 text-xs" data-testid={`reviews-dist-${n}`}>
              <span className={`font-mono w-6 ${muted}`}>{n}★</span>
              <span className={`flex-1 h-1.5 rounded-full overflow-hidden ${track}`}>
                <span className="block h-full rounded-full bg-[#E02128] transition-[width] duration-700" style={{ width: `${w}%` }} />
              </span>
              <span className={`font-mono w-6 text-right ${muted}`}>{c}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
